const mobileMenuBtn = document.getElementById("ocfp-main-mobile-toggle-btn");
const mobileMenu = document.querySelector(".ocfp-main-mobile-navs");

if (mobileMenuBtn) {
	mobileMenuBtn.addEventListener("click", (e) => {
		if (mobileMenu.classList.contains("ocfp-open-nav")) {
			closeMobileMenu(e);
		} else {
			openMobileMenu(e);
		}
	});
}

function openMobileMenu(e) {
	e?.preventDefault();
	mobileMenuBtn.setAttribute("aria-expanded", "true");
	mobileMenu.classList.add("ocfp-open-nav");
	const icon = mobileMenuBtn.querySelector("i");
	icon.className = "fa-solid fa-xmark";
}

function closeMobileMenu(e) {
	e?.preventDefault();
	mobileMenuBtn.setAttribute("aria-expanded", "false");
	mobileMenu.classList.remove("ocfp-open-nav");
	const icon = mobileMenuBtn.querySelector("i");

	icon.className = "fa-solid fa-bars";
}

const mobileNavs = document.querySelectorAll(".ocfp-main-mobile-navs .ofcp-main-mobile-nav");

if (mobileNavs.length > 0) {
	mobileNavs.forEach((nav) => {
		const headingBtn = nav.querySelector(".ofcp-main-mobile-menu-title");
		const navUl = nav.querySelector(".ocfp-mobile-navigation");

		if (headingBtn) {
			headingBtn.addEventListener("click", (e) => {
				e.preventDefault();
				navUl.classList.toggle("ocfp-main-mobile-open-sub-nav");
				headingBtn.classList.toggle("ocfp-main-mobile-open-sub-nav");
			});
		}
	});
}

// let currentURLSlug = window.location.pathname.split('/').slice(1)[0]
